export const AppLocalStorageItems = {
    RedirectUrl : 'redirectUrl',
    Key: '--key--',
    ProfilePic: 'ProfilePic',
    PageStateInformation: 'pageStateInformation',
    RefreshTokenTimeStamp:'refreshTokenTimeStamp'
}

export const AppLocalStorage = {
    getStorageItem: (key) => localStorage.getItem(key),
    setStorageItem: (key, value) => localStorage.setItem(key, value),
    removeStorageItem: (key) => localStorage.removeItem(key),
    clearLocalStorage: () => localStorage.clear()
}
